"use client";

import FiltersPanel from "@/app/search/facets/filtersPanel";
import Refinements from "@/app/search/facets/refinements";
import { CategoryFacetType } from "@/app/search/utils/createUsableCategoryFacet";
import { FilterType } from "@/types/search";
import SortByPanel from "@/components/sort-by-panel/sortByPanel";
import type { AlgoliaQuery } from "@/declarations/algoliaQuery";
import { useCallback, useState } from "react";
import styles from "./filters.module.scss";

type MobileFilterProps = {
  pageURI: string;
  categoryPageName: string;
  facets: Record<string, Record<string, number>> | undefined;
  categoryFacets: CategoryFacetType[];
  searchQuery: AlgoliaQuery;
};

export default function MobileFilterBar({
  pageURI,
  categoryPageName,
  categoryFacets,
  facets,
  searchQuery,
}: MobileFilterProps) {
  const [filterType, setFilterType] = useState<FilterType>("default");
  const [isFilterOpen, setFilterOpen] = useState(false);
  const [categoryResetSignal, setCategoryResetSignal] = useState(0);
  const [selectedValues, setSelectedValues] = useState<Record<string, Record<string, boolean>>>({});

  const toggleFilterPanel = useCallback(
    (filterType: FilterType) => {
      setFilterOpen(!isFilterOpen);
      setFilterType(filterType);
    },
    [isFilterOpen],
  );

  if (!facets) {
    return <></>;
  }

  return (
    <>
      <section id="sortBar" className={`${styles.customCard}`}>
        <SortByPanel pageURI={pageURI} toggleFilterPanel={toggleFilterPanel} viewMode={"list"} />
      </section>
      <FiltersPanel
        categoryPageName={categoryPageName}
        categoryFacets={categoryFacets}
        facets={facets}
        categoryResetSignal={categoryResetSignal}
        setCategoryResetSignal={setCategoryResetSignal}
        isOpen={isFilterOpen}
        filterType={filterType}
        onClose={toggleFilterPanel}
        isMobile
        setSelectedValues={setSelectedValues}
        searchQuery={searchQuery}
      />
      <Refinements
        excludedAttributes={["category.lvl0", "query"]}
        setCategoryResetSignal={setCategoryResetSignal}
        setSelectedValues={setSelectedValues}
        indexName={searchQuery.indexName}
      />
    </>
  );
}
